<ng-template #templateRef>
  <p>
    <a [href]="outgoingEmailsHref" target="_blank" class="link-item">
      <strong translate="parameters/quick_replies/details/graph/edit_api_connector/warn_outgoing_emails"></strong>
      <mat-icon>open_in_new</mat-icon>
    </a>
  </p>
  <p>
    <a
      class="link-item"
      href="https://developers.alcmeon.com/docs/how-to-use-api-external-authorization"
      rel="noopener noreferrer nofollow"
      target="_blank">
      <strong translate="parameters/quick_replies/details/graph/edit_api_connector/technical_documentation"></strong>
      <mat-icon>open_in_new</mat-icon>
    </a>
  </p>
  <section>
    <h2 translate="parameters/quick_replies/details/graph/edit_api_connector/api_request_title"></h2>
    <app-select
      [control]="requestFormGroup.controls.method"
      [items]="methodsItems"
      labelKey="parameters/quick_replies/details/graph/edit_api_connector/select_method_label"></app-select>
    <p>
      <mat-form-field>
        <mat-label translate="parameters/quick_replies/details/graph/edit_api_connector/url_label"></mat-label>
        <input matInput [formControl]="$any(requestFormGroup.controls.url)" />
      </mat-form-field>
    </p>

    <h2 translate="parameters/quick_replies/details/graph/edit_api_connector/external_authorization"></h2>
    <app-select
      [control]="$any(requestFormGroup.controls.externalAuthorizationId)"
      [items]="externalAuthorizations"
      labelKey="parameters/quick_replies/details/graph/edit_api_connector/external_authorization/select"></app-select>

    <h2 translate="parameters/quick_replies/details/graph/edit_api_connector/headers_label"></h2>
    <div class="header" *ngFor="let control of headersArray.controls; let index = index; let first = first">
      <mat-form-field>
        <mat-label translate="parameters/quick_replies/details/graph/edit_api_connector/header/name/label"></mat-label>
        <input matInput [formControl]="$any(headersArray.controls[index].get('name'))" />
      </mat-form-field>
      <strong> &nbsp;=&nbsp; </strong>
      <mat-form-field>
        <mat-label translate="parameters/quick_replies/details/graph/edit_api_connector/header/value/label"></mat-label>
        <input matInput [formControl]="$any(headersArray.controls[index].get('value'))" />
      </mat-form-field>
      <mat-icon
        aria-label="delete an header"
        (click)="deleteHeader(index)"
        color="danger"
        class="action"
        *ngIf="headersArray.controls.length">
        delete
      </mat-icon>
    </div>
    <p>
      <button mat-icon-button type="button" aria-label="add an header" (click)="addHeader()">
        <mat-icon color="primary"> add_circle </mat-icon>
      </button>
    </p>
    <p>
      <mat-form-field>
        <mat-label translate="parameters/quick_replies/details/graph/edit_api_connector/http_body/label"></mat-label>
        <input matInput [formControl]="$any(requestFormGroup.controls.httpBody)" />
        <mat-hint translate="parameters/quick_replies/details/graph/edit_api_connector/http_body/hint"></mat-hint>
      </mat-form-field>
      <span *ngIf="invalidJsonBody" class="warning-invalid-json">
        <span translate="parameters/quick_replies/details/graph/edit_api_connector/http_body/invalid-json-body"></span>
      </span>
    </p>

    <p>
      <button
        mat-raised-button
        color="primary"
        type="button"
        class="copy-curl-button"
        [disabled]="requestFormGroup.invalid"
        [attr.aria-label]="
          'parameters/quick_replies/details/graph/edit_api_connector/copy_curl_test_command' | translate
        "
        translate="parameters/quick_replies/details/graph/edit_api_connector/copy_curl_test_command"
        (click)="copyCurlTestCommand()"></button>
    </p>
  </section>

  <section>
    <h2 translate="parameters/quick_replies/details/graph/edit_api_connector/api_response_title"></h2>
    <div class="association" *ngFor="let control of responsesArray.controls; let index = index; let first = first">
      <mat-form-field>
        <mat-label
          translate="parameters/quick_replies/details/graph/edit_api_connector/api_response/json_path"></mat-label>
        <input matInput [formControl]="$any(responsesArray.controls[index].get('jsonPath'))" />
      </mat-form-field>
      <mat-icon class="separator">arrow_forward</mat-icon>
      <mat-form-field>
        <mat-label
          translate="parameters/quick_replies/details/graph/edit_api_connector/api_response/variable"></mat-label>
        <input matInput [formControl]="$any(responsesArray.controls[index].get('variable'))" />
      </mat-form-field>
      <mat-icon aria-label="delete an association" (click)="deleteAssociation(index)" color="danger" class="action">
        delete
      </mat-icon>
    </div>
    <button
      mat-icon-button
      type="button"
      aria-label="add an association"
      [disabled]="responsesArray.controls.length >= MAX_ASSOCIATION_NUMBER"
      (click)="addAssociation()">
      <mat-icon color="primary" [class.disabled]="responsesArray.controls.length >= MAX_ASSOCIATION_NUMBER">
        add_circle
      </mat-icon>
    </button>
  </section>
</ng-template>
